import { reflect } from '@effector/reflect';
import { useUnit } from 'effector-react';
import { CircleSlash2 } from 'lucide-react';
import { not } from 'patronum';
import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';
import { viewerModel } from 'entities/viewer';
import { ConfirmModalProps, createConfirmModal } from 'shared/ui';
import { BlockGameModel } from '../../model';

export const createBlockGameModal = (model: BlockGameModel) => {
	const ConfirmModal = createConfirmModal(model);

	const BlockGameModal = forwardRef<HTMLDivElement, ConfirmModalProps>(({ ...props }, ref) => {
		const { t } = useTranslation();

		const [game] = useUnit([model.$modalData]);

		return (
			<ConfirmModal
				ref={ref}
				title={t('block-game.title')}
				cancelButtonProps={{
					children: t('block-game.cancel'),
				}}
				submitButtonProps={{
					variant: 'outline',
					children: t('block-game.block'),
				}}
				{...props}
			>
				{t('block-game.description', { name: game?.game.title })}
			</ConfirmModal>
		);
	});

	const BlockGameModalActionIcon = reflect({
		view: ConfirmModal.ActionIcon,
		bind: {
			'data-test-id': 'block-game-action-icon',
			variant: 'ghost-secondary',
			disabled: not(viewerModel.$canBlockGames),
			children: <CircleSlash2 />,
		},
	});

	return Object.assign(BlockGameModal, {
		ActionIcon: BlockGameModalActionIcon,
	});
};
